import styled from 'styled-components'

const BlockHeader = styled.h2`
  font-weight: 300;
  font-size: 22px;
  margin-top: 32px;
  margin-bottom: 8px;
`

export default BlockHeader